import { isProjectTypeAdmin, isProjectTypeMember } from "@/core/lib/access";
import { CORPORATE_FINANCE_PROJECT_TYPE } from "@/core/lib/constants";

type UserLike = Parameters<typeof isProjectTypeMember>[0];

export const isCorporateFinanceAdmin = (user: UserLike): boolean =>
  isProjectTypeAdmin(user, CORPORATE_FINANCE_PROJECT_TYPE);

export const isCorporateFinanceMember = (user: UserLike): boolean =>
  isProjectTypeMember(user, CORPORATE_FINANCE_PROJECT_TYPE);
